// Именно 'three', а не './three': нужен только ShaderChunk (тот же объект,
// extras/three реэкспортирует его), зато модуль импортируется голым node в
// тестах — extensionless-импорты extras/three понимает только бандлер.
import { ShaderChunk } from 'three'

// Тун-шейдинг окружения (аниме-курс Дениса, 2026-07-27).
//
// Аватары уже рисуются MToon'ом (VRM), а мир вокруг — обычный PBR: плавный
// градиент света на стенах рядом с плоско освещёнными персонажами читается
// как серая каша. Здесь прямой свет солнца квантуется в две полосы — свет и
// тень с мягкой кромкой — так же, как это делает MToon: порог у терминатора,
// тень — доля света, а не чёрная.
//
// Почему onBeforeCompile, а не MeshToonMaterial: замена материала потеряла бы
// ambient от scene.environment — в мире нет ламп (см. world/apps/day-cycle.js),
// IBL — единственный заполняющий свет, и именно он не даёт теневой стороне
// зданий чернеть. Правка одной строки в RE_Direct_Physical сохраняет всё
// остальное: тени CSM, туман, эмиссию, карты и uber-инстансинг.
//
// directLight.color к точке вреза уже содержит тень CSM, поэтому затенённые
// места честно темнеют до ambient — полосы их не высветляют.
export const TOON_MARKER = 'vec3 irradiance = dotNL * directLight.color;'

const TOON_INCLUDE = '#include <lights_physical_pars_fragment>'

// Кромка света/тени у терминатора (0.10), тень — 45% прямого света: ниже мир
// чернеет в сумерках, выше пропадает объём. fwidth сглаживает кромку на
// кривых поверхностях, на плоских гранях срез остаётся резким.
const TOON_BANDS = `
	float csToonEdge = fwidth( dotNL ) * 1.5 + 1e-4;
	dotNL = mix( 0.45, 1.0, smoothstep( 0.10 - csToonEdge, 0.10 + csToonEdge, dotNL ) );
	vec3 irradiance = dotNL * directLight.color;`

let warned = false

export function toonifyMaterial(material) {
  if (!material?.isMeshStandardMaterial) return material
  if (material.userData?.toon === false) return material
  const prev = material.onBeforeCompile
  // Ключ кэша программ по умолчанию — onBeforeCompile.toString(), а исходник
  // обёртки одинаков для всех материалов. Без явного ключа материал с ветром
  // и без него получили бы одну программу (см. BUG-комментарий в glbToNodes)
  // — подмешиваем исходник предыдущего хука, чтобы развести их.
  const prevSource = prev ? String(prev) : ''
  material.customProgramCacheKey = () => `cs-toon|${prevSource}`
  material.onBeforeCompile = (shader, renderer) => {
    prev?.(shader, renderer)
    const chunk = ShaderChunk.lights_physical_pars_fragment
    if (!chunk?.includes(TOON_MARKER)) {
      if (!warned) {
        warned = true
        console.warn('[toon] маркер RE_Direct_Physical не найден — окружение осталось PBR, обнови TOON_MARKER под новую three')
      }
      return
    }
    shader.fragmentShader = shader.fragmentShader.replace(TOON_INCLUDE, chunk.replace(TOON_MARKER, TOON_BANDS))
  }
  return material
}
